import * as React from 'react'

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';

import { Helmet } from 'react-helmet';

import LogoIcon from '../../../assets/images/Logos/BHBUSMidia.webp';
import { AddressDiv, BaseDiv, ContactDiv, ContentDiv, CopyRight, IconsDiv, LeftSide, Logo, PrincipalDiv } from './styles';
import { useCallback } from 'react';

interface IFooterProps {
  lp?: boolean;
}


const Footer: React.FC<IFooterProps> = ({ lp }) => {
  const handleWhatsAppClick = useCallback(() => {
    window.open('https://api.whatsapp.com/send/?phone=5531982213102', '_blank');
  }, []);

  const handleLinkedinClick = useCallback(() => {
    window.open('https://br.linkedin.com/company/gomidiabh', '_blank');
  }, []);

  const handleInstagramClick = useCallback(() => {
    window.open('https://www.instagram.com/bhbusmidia/', '_blank');
  }, []);

  return (
    <PrincipalDiv>
      <Helmet>
        <link rel="preload" href={LogoIcon} as="image" type="image/webp" />
      </Helmet>
      <BaseDiv>
        <ContentDiv>
          <LeftSide>
            <Logo src={LogoIcon} alt="BHBUS Mídia Logo" />
            <AddressDiv>
              <h1>ONDE ESTAMOS</h1>
              <p>R. Aquiles Lobo, 504 - 9° andar</p>
              <p>Floresta, Belo Horizonte - MG</p>
            </AddressDiv>
          </LeftSide>
          <ContactDiv>
            <h1>Contato</h1>
            {lp ? (<p>Whatsapp: (31) 98302-4595</p>) : (<p>Whatsapp: (31) 98221 3102</p>)}
            
            <p>Comercial: (31) 3248 7095</p>
            <p>comercial@bhbusmidia.com.br</p>
            <IconsDiv>
              <InstagramIcon className="icons" onClick={handleInstagramClick} />
              <LinkedInIcon className="icons" onClick={handleLinkedinClick} />
              <WhatsAppIcon className="icons" onClick={handleWhatsAppClick} />
            </IconsDiv>
          </ContactDiv>
        </ContentDiv>
      </BaseDiv>
      <CopyRight>
        {lp ? (<p>© 2025 - Desenvolvido por <strong>BHBUS Mídia</strong></p>) : (<p>© 2024 - Desenvolvido por <strong>BHBUS Mídia</strong></p>)}
        <p>Todas as marcas registradas e direitos autorais pertencem aos seus respectivos proprietários</p>
      </CopyRight>
    </PrincipalDiv>
  );
};

export { Footer };